import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold">
            <span className="text-ttNavy-500">4</span>
            <span className="text-ttOrange-500">0</span>
            <span className="text-ttBlue-500">4</span>
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/"
              className="rounded-md bg-ttNavy-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-ttNavy-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ttNavy-600"
            >
              Go back home
            </Link>
            <Link
              href="/Contact"
              className="text-sm font-semibold text-ttOrange-400"
            >
              Contact us <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
